import { render, staticRenderFns } from "./ThemeLayoutSelector.vue?vue&type=template&id=20dc66c0&scoped=true"
import script from "./ThemeLayoutSelector.vue?vue&type=script&lang=js"
export * from "./ThemeLayoutSelector.vue?vue&type=script&lang=js"
import style0 from "./ThemeLayoutSelector.vue?vue&type=style&index=0&id=20dc66c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc66c0",
  null
  
)

export default component.exports